import React, { useEffect } from 'react';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { subPlanType, useIdcw } from '../../../hooks/useIdcw';

export type idcwDetailsType = {
    isin: string;
    idcwOption: string;
};

type IdcwOptionsProps = {
    subPlans: Array<subPlanType>;
    setIdcwDetails: React.Dispatch<React.SetStateAction<idcwDetailsType | null>>;
};

export default function IdcwOptions({ subPlans, setIdcwDetails }: IdcwOptionsProps) {
    const idcwOptions = useIdcw({ subPlans: subPlans });
    const [idcwOption, setIdcwOption] = React.useState(idcwOptions[0]);
    useEffect(() => {
        setIdcwDetails({ isin: idcwOption.isin, idcwOption: idcwOption.optionValue });
    }, [idcwOption]);
    return (
        <div className="idcw-options-dropdown">
            <FormControl variant="filled" className="mf-investment-select">
                <p>Select IDCW Option</p>
                <Select
                    labelId="select-idcw-label"
                    id="select-idcw"
                    value={idcwOption.optionValue}
                    onChange={(e) => {
                        const currentOption = idcwOptions.find(
                            (idcwOption) => idcwOption.optionValue === e.target.value,
                        );
                        if (!!currentOption) {
                            setIdcwOption(currentOption);
                        }
                    }}
                >
                    {idcwOptions.map((option) => (
                        <MenuItem value={option.optionValue}>{option.optionName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
